import { v4 } from 'uuid';
import type { TQuestionStep } from '@/types/common';

const createLoading = (): TQuestionStep => ({
	id: v4(),
	question: '',
	answer: '',
	isLoading: true
});

const calcTargetLoading = (real: number, initial: number, cols: number) => {
	if (real < initial) {
		return initial - real;
	}
	const overflow = real - initial;
	const remainder = overflow % cols;
	return remainder === 0 ? cols : cols - remainder;
};

export const buildScrapingSteps = (
	current: TQuestionStep[],
	step: TQuestionStep,
	initialLoadingCount = 9,
	cols = 3
): TQuestionStep[] => {
	let replaced = false;
	let realCount = 0;
	let loadingCount = 0;

	const next: TQuestionStep[] = [];

	for (const item of current) {
		if (!replaced && item.isLoading) {
			replaced = true;
			next.push({ ...step, id: item.id });
			realCount++;
		} else {
			next.push(item);
			item.isLoading ? loadingCount++ : realCount++;
		}
	}

	if (!replaced) {
		next.push(step);
		realCount++;
	}

	const targetLoading = calcTargetLoading(realCount, initialLoadingCount, cols);
	const diff = targetLoading - loadingCount;

	if (diff !== 0) {
		const loadings = next.filter((s) => s.isLoading);
		const reals = next.filter((s) => !s.isLoading);

		return [
			...reals,
			...(diff > 0
				? loadings.concat(Array.from({ length: diff }, createLoading))
				: loadings.slice(0, targetLoading))
		];
	}

	return next;
};
